import { Meta, theme } from 'aimo-ui';
import SkeletonLoaderRow, {
  SkeletonWrapper,
} from 'components/loading/SkeletonLoaderRow';
import FlatListCustom from 'components/sheets/FlatListCustom';
import { useParkingZoneSearch } from 'hooks/useParkingZoneSearch';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from 'styles/CommonLayoutStyles';
import { testIdentifiers } from 'utils/testIdentifiers';
import ChargerSkeleton from '../evcharge/chargerSelection/ChargerSkeleton';
import { MarginView, Row } from '../styles/styles';
import ChargerSearchItem from './ChargerSearchItem';

type ChargerSearchResultsListProps = {
  searchTerm: string;
  withLTP?: boolean;
};

const ItemSeparator = () => <Divider marginVertical={10} />;
const ListFooter = () => <MarginView />;

const ChargerSearchResultsList: React.FC<ChargerSearchResultsListProps> = ({
  searchTerm,
  withLTP,
}) => {
  const { t } = useTranslation();

  const { evConnectors, loading } = useParkingZoneSearch({
    searchTerm,
    withLTP,
  });

  const foundConnectors = evConnectors?.searchEvConnectors;

  if (loading) {
    return (
      <>
        <Row mt={15} mb={15}>
          <SkeletonWrapper width={80}>
            <SkeletonLoaderRow height={15} />
          </SkeletonWrapper>
        </Row>
        <ChargerSkeleton lastElement />
      </>
    );
  }

  if (!foundConnectors || foundConnectors.length === 0) {
    return null;
  }

  return (
    <>
      <Row mt={15} mb={15}>
        <Meta
          {...testIdentifiers('results-label-charging')}
          color={theme.colors.gray300}>
          {t('search.chargerResults', { amount: foundConnectors.length })}
        </Meta>
      </Row>
      <FlatListCustom
        ItemSeparatorComponent={ItemSeparator}
        data={foundConnectors}
        renderItem={({ item }) => <ChargerSearchItem item={item} />}
        ListFooterComponent={ListFooter}
        keyExtractor={(item, index) =>
          `charger-${item?.publicDisplayId || index}`
        }
        {...testIdentifiers('search-results-chargers-list')}
      />
    </>
  );
};

export default ChargerSearchResultsList;
